// src/components/AppleInput.tsx
import React from "react";
import clsx from "clsx";
import { A } from "../styles/appleClasses";

type AppleInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  isNumber?: boolean;
};

export function AppleInput({ className, isNumber, ...props }: AppleInputProps) {
  return (
    <input
      {...props}
      className={clsx(
        A.inputBase,
        isNumber && A.num,
        props.disabled && A.fieldDisabled,
        className
      )}
    />
  );
}